import {Component, OnInit, ViewContainerRef, ViewChild, Input, ElementRef} from '@angular/core';
import { NdmsFormControlComponent } from '../../forms/ndms-form-control/ndms-form-control.component';

@Component({
  selector: 'textbox',
  templateUrl: './textbox.component.html',
  styleUrls: ['./textbox.component.scss']
})
export class TextboxComponent extends NdmsFormControlComponent implements OnInit {
  @ViewChild('control') textBox: HTMLInputElement
  @ViewChild('control') el: ElementRef
  @Input() focus: boolean= false;
  constructor(viewContainerRef: ViewContainerRef) {
    super(viewContainerRef);
  }

  ngOnInit() {
    if(this.textBox)
      this.textBox.autofocus = this.focus;
  }
  ngAfterViewInit() {
    if(this.focus)
      this.el.nativeElement.focus();
  }
  getMask() {
    let maskConfig: any = {};

    if (this.mask) {
      switch (this.mask) {
        case "phone":
          maskConfig.mask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
          break;
        case "socialSecurityNumber":
          maskConfig.mask = [/\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
          break;
        default: 
          maskConfig.mask = [];
      }
    }
    else
    {
      maskConfig.mask = false;
    }

    return maskConfig;
  }

}
